export const RELATABLE_TYPES = {
  COMMUNITY_SPACE: 'CommunitySpace',
};
